import { render, staticRenderFns } from "./c-logedit.vue?vue&type=template&id=adbd5f22&scoped=true"
import script from "./c-logedit.vue?vue&type=script&lang=js"
export * from "./c-logedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbd5f22",
  null
  
)

export default component.exports